import { Link } from 'react-router-dom';

export function Unauthorized() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg text-center">
        <h2 className="text-3xl font-bold text-red-600">Access Denied</h2>
        <p className="text-gray-600 mt-4">
          You don't have permission to view this page
        </p>
        <Link
          to="/login"
          className="mt-6 inline-block px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          Return to Login
        </Link>
      </div>
    </div>
  );
}